<template>
  <div class="page-body">
    <div class="container-fluid">
      <div class="edit-profile">
        <div class="row">
          <div class="col-12 col-xl-12">
            <div class="card">
              <div class="card-header">
                <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                  {{ categoryId && categoryId !== '' ? "Editar Post" : "Crear Post" }}
                </div>
              </div>
              <div class="card-body" style="margin-top: 20px;">
                <form @submit.prevent="submitForm">
                  <div class="flex flex-col md:flex-row gap-4 md:gap-8">
                    <div class="flex flex-col md:flex-row w-full space-y-4 md:space-y-0 md:space-x-4">
                      <!-- Columna 1: Área para cargar archivos -->
                      <div class="w-full md:w-1/3 flex flex-col gap-4 items-center">
                        <!-- Contenedor principal para arrastrar y cargar archivos -->
                        <div class="w-full relative">
                          <input 
                            type="file" 
                            accept="image/*" 
                            @change="handleFileUpload" 
                            class="absolute inset-0 opacity-0 cursor-pointer z-10"
                          />
                          <div class="w-full h-[200px] flex items-center justify-center rounded-2xl border-2 border-[#ff4265] overflow-hidden relative">
                            <div 
                              v-if="!form.file_blog" 
                              class="text-neutral-500 text-base font-light font-['Poppins'] leading-normal text-center"
                            >
                              Arrastra aquí tu imagen
                            </div>
                            <img 
                              v-if="form.file_blog || existingImageSrc" 
                              :src="form.file_blog || existingImageSrc" 
                              alt="Vista previa de la imagen" 
                              class="absolute inset-0 w-full h-full object-cover pointer-events-none" 
                            />
                            <button 
                              v-if="form.file_blog"
                              @click.stop="removeImage"
                              class="absolute top-2 right-2 bg-white text-red-500 rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-500 hover:text-white transition duration-300 z-20"
                              title="Quitar imagen"
                            >
                              &times; <!-- Símbolo de X -->
                            </button>
                          </div>
                          <!-- Alerta para imagen -->
                          <div v-if="showImageAlert" class="required-alert">
                            <div class="yellow-box">!</div>
                            <span>Coloca una imagen</span>
                          </div>
                        </div>
                      </div>

                      <!-- Columnas 2 y 3: Se apilan en móvil -->
                      <div class="w-full md:w-2/3 flex flex-col md:flex-row gap-4">
                        <!-- Columna 2: Título y Estatus -->
                      <div class="w-full md:w-1/2 flex flex-col gap-4">
                        <div class="w-full flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Título</label>
                          <input 
                            type="text" 
                            v-model="form.title"
                            @input="validateField('title')"
                            class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal" 
                            placeholder="Título del post" 
                            
                          />
                          <!-- Alerta para título -->
                          <div v-if="showTitleAlert" class="required-alert">
                            <div class="yellow-box">!</div>
                            <span>Completa este campo</span>
                          </div>
                        </div>

                        <div class="w-full flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Estatus</label>
                          <select 
                            v-model="form.status"
                            @change="validateField('status')"
                            class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                            
                          >
                            <option value="" disabled>Selecciona una opción</option>
                            <option value="Activo">Activo</option>
                            <option value="Desactivado">Desactivado</option>
                            <!-- <option value="Eliminado">Eliminado</option> 
                            <option value="Publicado">Publicado</option> -->
                            <option value="Borrador">Borrador</option>
                          </select>
                          <!-- Alerta para estatus -->
                          <div v-if="showStatusAlert" class="required-alert">
                            <div class="yellow-box">!</div>
                            <span>Selecciona un estatus</span>
                          </div>
                        </div>
                      </div>

                      <!-- Columna 3: Categoría -->
                      <div class="w-full md:w-1/2 flex flex-col gap-4">
                        <div class="flex flex-1 flex-col p-2 text-gray-900">
                          <label class="text-style-sm mb-1">Categoría</label>
                          <select 
                            class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" 
                            v-model="form.category"
                            @change="validateField('category')"
                            
                          >
                            <option value="" disabled selected>Selecciona una categoria</option>
                            <option v-for="company in categories" :key="company.id" :value="company.id">
                              {{ company.name }}
                            </option>
                          </select>
                          <!-- Alerta para categoría -->
                          <div v-if="showCategoryAlert" class="required-alert">
                            <div class="yellow-box">!</div>
                            <span>Selecciona una categoría</span>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Descripción -->
                  <div class="w-full flex flex-col gap-2 mt-4">
                    <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">
                      Resumen
                    </label>
                    <textarea 
                      v-model="form.summary"
                      @input="validateField('summary')"
                      class="w-full px-4 py-[20px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                      placeholder="Descripción del post" 
                    ></textarea>
                    <!-- Alerta para resumen -->
                    <div v-if="showSummaryAlert" class="required-alert">
                      <div class="yellow-box">!</div>
                      <span>Añade un resumen</span>
                    </div>
                  </div>

                  <!-- Contenido -->
                  <div class="w-full flex flex-col gap-2 mt-4">
                    <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">
                      Contenido
                    </label>
                    <div class="w-full text-white p-2 rounded-md">
                      <ckeditor
                        v-model="form.contenido_post"
                        @input="validateField('contenido_post')"
                        :editor="editor"
                        :config="editorConfig"
                        class="w-full"
                      ></ckeditor>
                    </div>
                    <!-- Alerta para contenido -->
                    <div v-if="showContentAlert" class="required-alert">
                      <div class="yellow-box">!</div>
                      <span>Añade contenido a tu post</span>
                    </div>
                  </div>

                  <!-- Botón -->
                  <div class="form-footer text-end mt-4">
                    <button type="button" class="custom-cancel-btn" @click="cancelChanges">
                      <span class="custom-cancel-btn-text">Cancelar</span>
                    </button>
                    <button type="submit" class="custom-create-btn" :disabled="isSubmitting "
                    :class="{ 'disabled-button': isSubmitting }">
                      <span class="custom-create-btn-text flex justify-center items-center w-full">{{ isSubmitting ? 'Guardando...' : 'Guardar' }}</span>
                    </button>
                  </div>
                </form>
              </div>
              <!-- Mensaje de éxito -->
              <div v-if="successMessage" class="user-alert">
                <div class="user-alert-content">
                  <div class="user-alert-text">
                    {{ successMessage }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  setup() {
    const store = useStore();
    let existingImageSrc = ref(null);
    const session = computed(() => store.getters.getUserSession);
    const route = useRoute();
    const categoryId = computed(() => route.params.id);
    const isLoading = ref(true);
    const editor = ref(ClassicEditor);
    const isSubmitted = ref(false);
    const isSubmitting = ref(false); // Bloqueo de boton guardar

    // Variables para controlar las alertas
    const showImageAlert = ref(false);
    const showTitleAlert = ref(false);
    const showStatusAlert = ref(false);
    const showCategoryAlert = ref(false);
    const showSummaryAlert = ref(false);
    const showContentAlert = ref(false);

    const editorConfig = {
      toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "link",
        "blockQuote",
        "|",
        "undo",
        "redo",
        "|",
        "numberedList",
        "bulletedList",
        "|",
        "alignment",
        "indent",
        "outdent",
        "|",
        "insertHR",
        "code",
        "codeBlock",
        "removeFormat",
        "|",
        "fontSize",
        "fontFamily",
        "fontColor",
        "backgroundColor",
        "highlight",
      ],
      colorButton_enableMore: true,
      contentsCss: [
        "body { background-color: white !important; color: black !important; }"
      ]
    };

    const form = ref({
      title: "",
      status: "",
      category: "",
      summary: "",
      contenido_post: "",
      file_blog: "",
      author_id: session.value.id,
      remove_image: false,
    });
    const successMessage = ref("");
    const router = useRouter();
    const categories = ref([]);

    // Función para validar campos
    const validateField = (field) => {
  let isValid = true;
  
  switch(field) {
    case 'image':
      // No validar imagen si es borrador
      showImageAlert.value = form.value.status !== "Borrador" && 
                       !form.value.file_blog && 
                       !existingImageSrc.value;
      isValid = !showImageAlert.value;
      break;
    case 'title':
      showTitleAlert.value = form.value.title.trim() === '';
      isValid = !showTitleAlert.value;
      break;
    case 'status':
      showStatusAlert.value = form.value.status.trim() === '';
      isValid = !showStatusAlert.value;
      break;
    case 'category':
      showCategoryAlert.value = form.value.category === '';
      isValid = !showCategoryAlert.value;
      break;
    case 'summary':
      showSummaryAlert.value = form.value.summary.trim() === '';
      isValid = !showSummaryAlert.value;
      break;
    case 'contenido_post':
      showContentAlert.value = form.value.contenido_post.trim() === '';
      isValid = !showContentAlert.value;
      break;
  }
  
  return isValid;
};

    const loadRoleData = async () => {
      if (categoryId .value) {
        try {
          const token = session.value.token_api;
          if (!token) {
            console.error("No se ha encontrado el token de autenticación.");
            return;
          }

          const options = {
            headers: {
              Authorization: `Bearer ${token}`
            }
          };

          const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/post-blog/${categoryId.value}`, options);
          if (response.status === 200) {
            let receivedStatus = response.data.post.status;
            if (receivedStatus === 'Publicado') {
              receivedStatus = 'Activo';
            } else if (receivedStatus === 'Eliminado') {
              receivedStatus = 'Desactivado';
            }

            form.value.title = response.data.post.title;
            form.value.status = response.data.post.status;
            form.value.category = response.data.post.category_id;
            form.value.summary = response.data.post.summary;
            form.value.contenido_post = response.data.post.content;
            form.value.file_blog = response.data.post.banner;
            existingImageSrc.value = response.data.post.banner;
            console.log(response.data.post.banner);
          }
        } catch (error) {
          console.error("Error al cargar los datos del rol:", error);
        }
      }
    };

    async function fetchCategorias() {
      try {
        let options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`
          }
        };
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/list-categorias`, options);
        if (response.status === 401) {
          store.dispatch('clearUser Session');
        }
        if (response.status === 200 && response.data?.data) {
          categories.value = response.data.data; 
        } else {
          console.error("Error en la respuesta de la API: estructura inesperada");
        }
      } catch (error) {
        console.error("Error al obtener los cargos:", error);
      } finally {
        isLoading.value = false;
      }
    }

    onMounted(() => {
      loadRoleData();
      fetchCategorias();
    });

    const removeImage = () => {
      form.value.file_blog = '';
      existingImageSrc.value = '';
      form.value.remove_image = true; // Marcar para eliminación
    };

    const submitForm = async () => {
      
      // Limpiar todas las alertas primero
      showTitleAlert.value = false;
      showStatusAlert.value = false;
      showCategoryAlert.value = false;
      showSummaryAlert.value = false;
      showContentAlert.value = false;

      // Solo validar la imagen si no es un borrador
      if (form.value.status !== "Borrador") {
      showImageAlert.value = !form.value.file_blog;
      if (showImageAlert.value) return;
      }

      // Validar campos en orden de importancia
      if (!validateField('image')) return;
      if (!validateField('title')) return;
      if (!validateField('status')) return;
      if (!validateField('category')) return;
      if (!validateField('summary')) return;
      if (!validateField('contenido_post')) return;

      const isValid = validateField('title') && 
                 validateField('status') && 
                 validateField('category') && 
                 validateField('summary') && 
                 validateField('contenido_post');

      if (!isValid || isSubmitting.value) {
        isSubmitting.value = false;
        return;
      }isSubmitting.value = true;

      try {
        const token = session.value.token_api;
        if (!token) {
          console.error("No se ha encontrado el token de autenticación.");
          isSubmitting.value = false;
          return;
        }

        const options = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        };

        const dataToSend = { 
          id: categoryId.value || null,
          ...form.value,
          category: form.value.category === "0" ? null : Number(form.value.category),
          file_blog: form.value.file_blog,
          remove_image: form.value.remove_image // Enviar flag de eliminación
        };

        const method = categoryId.value ? "post" : "post";
        const endpoint = `${process.env.VUE_APP_API_BASE_URL}/post-blog${categoryId.value ? `/${categoryId.value}` : ''}`;
        
        const response = await axios[method](endpoint, dataToSend, options);
      
        if (response.status === 200 || response.status === 201) {
          successMessage.value = "Post guardado con éxito.";

          setTimeout(() => {
            successMessage.value = "";
            router.push({ name: "post_list" });
          }, 2000);
        }
      } catch (error) {
        console.error("Error al guardar el cargo:", error);
        if (error.response) {
          console.error("Error de servidor:", error.response.data);
        }
      } finally {
        isSubmitted.value = false;
      }
    };

    const handleFileUpload = async (event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          form.value.file_blog = e.target.result;
          form.value.remove_image = false; // Resetear flag de eliminación
        };
        reader.readAsDataURL(file);
      }
    };

    const cancelChanges = () => {
      router.push({ name: "post_list" });
    };

    return {
      categoryId,
      form,
      submitForm,
      successMessage,
      categories,
      editorConfig,
      editor,
      handleFileUpload,
      removeImage,
      isSubmitting,
      isSubmitted,
      showImageAlert,
      showTitleAlert,
      showStatusAlert,
      showCategoryAlert,
      showSummaryAlert,
      showContentAlert,
      cancelChanges,
      validateField
    };
  }
};
</script>

<style>
  .ck-editor__editable_inline {
    background-color: rgb(253, 253, 253) !important;
    color: rgb(9, 9, 9) !important;
  }

  .disabled-button {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .required-alert {
    display: flex;
    align-items: center;
    background-color: #fff;
    color: #333;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-top: 5px;
    position: relative;
    max-width: 300px;
    word-wrap: break-word;
  }

  .required-alert .yellow-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    background-color: #e59035;
    margin-right: 10px;
    border: 1px solid #e59035;
    border-radius: 4px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    line-height: 1;
  }

  .required-alert::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 20px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    z-index: 1;
  }

  .required-alert::before {
    content: "";
    position: absolute;
    top: -11px;
    left: 19px;
    width: 0;
    height: 0;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-bottom: 11px solid #ccc;
    z-index: 0;
  }

  .custom-cancel-btn {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #4B5563; /* Gris oscuro */
  border: 1px solid #4B5563;
  color: white;
  cursor: pointer;
  margin-right: 10px; /* Espacio entre botones */
  transition: all 0.3s ease;
}

.custom-cancel-btn-text {
  color: #FFF;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media (max-width: 767px) {
    .card-body {
      padding: 15px;
    }
    
    .flex-col-mobile {
      flex-direction: column;
    }
    
    .w-full-mobile {
      width: 100% !important;
    }
    
    .space-x-4 {
      margin-left: 0;
      margin-right: 0;
    }
    
    .gap-8 {
      gap: 1rem;
    }
    
    .ck-editor__editable_inline {
      min-height: 200px;
    }
    
    .form-footer {
      flex-direction: column;
      gap: 10px;
    }
    
    .custom-cancel-btn, 
    .custom-create-btn {
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
      text-align: center;
      justify-content: center;
      align-items: center;
    }
  }

  @media (min-width: 768px) {
    .form-footer {
      justify-content: flex-end;
      gap: 10px;
    }
  }
</style>